<template>
    <div class="lang-menu">
        <v-btn
            v-ripple="{ class: 'text-blue3' }"
            color="blue1"
            :small="$vuetify.breakpoint.mdAndUp"
            depressed
            class="text-white1"
            outlined
            @click="toggleLoginMenu"
        >
            {{ $t('header.btns.btn1') }}
        </v-btn>

        <!-- 로그인 버전 선택 드롭다운 -->
        <div
            v-if="isLoginMenuOpen"
            class="lang-menu__dropdown"
        >
            <ul
                class="lang-menu__list"
                style="white-space: nowrap;"
            >
                <li
                    v-for="(item, index) in loginOptions"
                    :key="index"
                    class="lang-menu__item"
                    @click="navigateTo(item.route)"
                >
                    {{ item.label }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginMenu',
    data() {
        return {
            isLoginMenuOpen: false,
            loginOptions: [
                {
                    label: '오픈배지 2.0',
                    route: { name: 'UserForOpenbadgePage', params: { lang: this.getLang() } },
                },
                {
                    label: '오픈배지 3.0',
                    route: { name: 'UserForOpenbadgeV3Page', params: { lang: this.getLang() } },
                },
            ],
        };
    },
    methods: {
        toggleLoginMenu() {
            this.isLoginMenuOpen = !this.isLoginMenuOpen;
        },
        navigateTo(route) {
            this.$router.push(route);
            this.isLoginMenuOpen = false;
        },
        getLang() {
            return this.$route.params.lang || 'kor';
        },
    },
};
</script>